import React from 'react';

import styles from './Spinner.module.css';

export default function Spinner({
  size,
  armCount = 12,
  animationDurationMs = 1000,
  armWidth = 0.075,
  armHeight = 0.25,
  armCornerRadius = 0.03,
}: {
  size: string;
  armCount?: number;
  animationDurationMs?: number;
  armWidth?: number;
  armHeight?: number;
  armCornerRadius?: number;
}) {
  return (
    <div
      className={styles.Spinner}
      style={{
        // @ts-ignore
        '--size': size,
        '--animation-duration': `${animationDurationMs}ms`,
        '--arm-width': armWidth,
        '--arm-height': armHeight,
        '--arm-corner-radius': armCornerRadius,
      }}
    >
      {Array(armCount)
        .fill(undefined)
        .map((_, i) => (
          <div
            key={`${armCount}-${i}`}
            style={{
              // @ts-ignore
              '--rotate': `${i / armCount}turn`,
              animationDelay: `${
                -animationDurationMs + ((i + 1) * animationDurationMs) / armCount
              }ms`,
            }}
          />
        ))}
    </div>
  );
}
